import Router from 'next/router'

function pushBack() {
  if (process.browser) {
    if (window.history.state.idx === 0) return Router.push('/')
    Router.back()
  }
}

export default pushBack
